// extracted by mini-css-extract-plugin
export default {"wrapper":"bpIfIr","stretch":"g0y9xC"};